import { render } from "./ServiceConnectionPromt.vue?vue&type=template&id=2f82d0cc&scoped=true&ts=true"
import script from "./ServiceConnectionPromt.vue?vue&type=script&lang=ts"
export * from "./ServiceConnectionPromt.vue?vue&type=script&lang=ts"

import "./ServiceConnectionPromt.vue?vue&type=style&index=0&id=2f82d0cc&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f82d0cc"]])

export default __exports__